import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const APP_NAME = 'Massrestaurant';

// Section names shown in the browser tab as "Sección · Massrestaurant".
// Keys are path prefixes; the longest matching prefix wins, so /new-order/takeout
// resolves to "Nueva Orden" and /subscription/success to "Suscripción".
// Kept in Spanish to match the sidebar labels in MainLayout.
const SECTION_TITLES: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/orders': 'Órdenes',
  '/new-order': 'Nueva Orden',
  '/tables': 'Mesas',
  '/kitchen': 'Cocina',
  '/daily-menus': 'Menú del Día',
  '/cash-register': 'Caja',
  '/admin/cash-registers': 'Caja',
  '/shift-closings': 'Cierres de Turno',
  '/facturas': 'Facturación',
  '/finanzas': 'Finanzas',
  '/clientes-fiscales': 'Clientes Fiscales',
  '/receipts': 'Recibos',
  '/inventory': 'Inventario',
  '/reports': 'Reportes',
  '/payment-methods': 'Métodos de Pago',
  '/menu-management': 'Gestión de Menú',
  '/user-management': 'Usuarios',
  '/areas-tables': 'Áreas y Mesas',
  '/configuracion': 'Configuración',
  '/restaurant-settings': 'Configuración',
  '/facturacion-settings': 'Configuración de Facturación',
  '/printer-settings': 'Impresoras',
  '/system-settings': 'Sistema',
  '/subscription': 'Suscripción',
  '/select-plan': 'Planes',
  '/login': 'Iniciar Sesión',
  '/auth/login': 'Iniciar Sesión',
  '/register': 'Crear Cuenta',
  '/auth/register': 'Crear Cuenta',
  '/session-expired': 'Sesión Expirada',
  '/autofactura': 'Autofactura',
  // '/menu-digital-settings' ya no existe: el menú digital es una pestaña de
  // Gestión del Menú, y '/menu/{slug}' (la pública) pone el nombre del
  // restaurante como título en cuanto carga.
};

// Prefixes sorted longest-first so the most specific route wins.
const SORTED_PREFIXES = Object.keys(SECTION_TITLES).sort((a, b) => b.length - a.length);

export const getSectionTitle = (pathname: string): string | undefined => {
  const prefix = SORTED_PREFIXES.find(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );
  return prefix ? SECTION_TITLES[prefix] : undefined;
};

// Renders nothing; keeps document.title in sync with the current route.
// Mounted once inside <Router> so it covers every page, including the ones
// outside MainLayout (login, autofactura, subscription flow).
const PageTitle: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const section = getSectionTitle(pathname);
    document.title = section ? `${section} · ${APP_NAME}` : APP_NAME;
  }, [pathname]);

  return null;
};

export default PageTitle;
